import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { Promocion, SavePromocion, cmbCondicionPago, cmbControlCantidad, cmbControlMaximo, cmbEspecifCalculoCantidad, cmbExcluyePromosHH, cmbSiNo, cmboInclusionExclusion } from '../../modelos/Promocion';
import { PromocionesService } from '../../services/promociones.service';
import { ValidatorAsyncCheckPromocion } from '../../promocion.validator';
import { moduloAmbiente } from '../../../../../assets/ambiente/ambienteModulo.js';

@Component({
  selector: 'app-promocion-form',
  templateUrl: './promocion-form.component.html',
  styleUrls: ['./promocion-form.component.css']
})
export class PromocionFormComponent implements OnInit {

  isCreate: boolean = true;
  fechaFinalMenorQueFechaInicial = false;
  condicionPagoDisabled = true;
  porcentajeDescuentoDisabled = true;
  agregarForm!: FormGroup;
  cmbSiNo = cmbSiNo;
  cmbExcluyePromosHH = cmbExcluyePromosHH;
  cmbEspecifCalculoCantidad = cmbEspecifCalculoCantidad;
  cmbControlCantidad = cmbControlCantidad;
  cmbControlMaximo = cmbControlMaximo;
  cmbCondicionPago = cmbCondicionPago;
  cmboInclusionExclusion = cmboInclusionExclusion;
  _promocion?: Promocion;
  environmentActual:  string;
  isProductivo: boolean = false;

  @Input()
  cmbTipoPromocion = [];

  @Input()
  loading: boolean;

  @Input()
  set promocion(data: Promocion | undefined) {
    if (data) {
      this.isCreate = false;
      this.agregarForm.patchValue(data);
      this.agregarForm.get('fecha_fin').setValue(data.fecha_fin.split('T')[0]);
      this.agregarForm.get('fecha_inicio').setValue(data.fecha_inicio.split('T')[0]);
      this._promocion = data;
    }
  }

  @Output()
  create = new EventEmitter<SavePromocion>();

  @Output()
  back = new EventEmitter<void>();

  get condicionMarca() {
    const value = this.agregarForm.get('cond_marca_submarca').value;
    return value == 1 || value == 2;
  }
  get condicionGrupo() {
    const value = this.agregarForm.get('cond_grupo_cliente').value;
    return value == 1 || value == 2;
  }
  get condicionCliente() {
    const value = this.agregarForm.get('cond_cliente').value;
    return value == 1 || value == 2;
  }
  get condicionOficina() {
    const value = this.agregarForm.get('cond_oficina_venta').value;
    return value == 1 || value == 2;
  }
  get condicionVendedor() {
    const value = this.agregarForm.get('cond_vendedor').value;
    return value == 1 || value == 2;
  }
  get condicionPorTier() {
    const value = this.agregarForm.get('cond_tiers').value;
    return value == 1 || value == 2;
  }

  // T.20331 Essential:  nuevas condiciones de promoción
  get condicionAgrupaTarifa() {
    const value = this.agregarForm.get('cond_sub_canal').value;
    return value == 1 || value == 2;
  }
  get condicionCanalVendedor() {
    const value = this.agregarForm.get('cond_canal_cliente').value;
    return value == 1 || value == 2;
  } 
  // T.20331

  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly promocionesService: PromocionesService,
  ) {
    this.buildForm();
  }

  ngOnInit(): void {

    this.environmentActual = moduloAmbiente.currentEnvironment;
    console.log(this.environmentActual);
    this.isProductivo = this.environmentActual == 'LOCAL' || this.environmentActual == 'DESARROLLO' ? false : true;

    this.agregarForm.get('fecha_inicio').valueChanges.subscribe((resp) => {
      if (this.agregarForm.get('fecha_fin').value && this.agregarForm.get('fecha_fin').value < this.agregarForm.get('fecha_inicio').value) {
        this.fechaFinalMenorQueFechaInicial = true;
      }
      else {
        this.fechaFinalMenorQueFechaInicial = false;
      }
    });

    this.agregarForm.get('fecha_fin').valueChanges.subscribe((resp) => {
      if (this.agregarForm.get('fecha_fin').value && this.agregarForm.get('fecha_fin').value < this.agregarForm.get('fecha_inicio').value) {
        this.fechaFinalMenorQueFechaInicial = true;
      }
      else {
        this.fechaFinalMenorQueFechaInicial = false;
      }
    });

    this.agregarForm.get('cambio_condicion_pago').valueChanges.subscribe((resp) => {
      if (resp == "SI") {
        this.condicionPagoDisabled = false;
        this.agregarForm.get('condicion_pago').setValidators([]);
        this.agregarForm.get('condicion_pago').updateValueAndValidity();
        this.agregarForm.get("condicion_pago").enable();
      }
      else this.condicionPagoDisabled = true;
    });

    /*this.agregarForm.get('aplica_compensacion').valueChanges.subscribe((resp) => {
      if (resp == "SI") {
        this.porcentajeDescuentoDisabled = false;
        this.agregarForm.get('porcentaje_descuento').setValidators([]);
        this.agregarForm.get('porcentaje_descuento').updateValueAndValidity();
        this.agregarForm.get("porcentaje_descuento").enable();
      }
      else this.porcentajeDescuentoDisabled = true;
    });*/

    this.agregarForm.get('aplica_compensacion').valueChanges.subscribe((value) => {
      if (value === '1') {
        this.agregarForm.get('porcentaje_descuento').enable();
      } else {
        this.agregarForm.get('porcentaje_descuento').disable();
      }
    });

    if (this.isCreate) {
      this.nuevo();
    } else {
      this.onChangeTipo(this.agregarForm.get('tipo_promo').value);
      this.agregarForm.get('suma_por_grupos').valueChanges.subscribe((value) => {
        if (value == 1 && this.agregarForm.valid && !this.loading)
          this.save(true);
      });
      this.agregarForm.get('cond_marca_submarca').valueChanges.subscribe(this.validateConditionAndSavePromo);
      this.agregarForm.get('cond_grupo_cliente').valueChanges.subscribe(this.validateConditionAndSavePromo);
      this.agregarForm.get('cond_cliente').valueChanges.subscribe(this.validateConditionAndSavePromo);
      this.agregarForm.get('cond_vendedor').valueChanges.subscribe(this.validateConditionAndSavePromo);
      this.agregarForm.get('cond_oficina_venta').valueChanges.subscribe(this.validateConditionAndSavePromo);
      this.agregarForm.get('cond_tiers').valueChanges.subscribe(this.validateConditionAndSavePromo);

      // T.20331 Essential:  nuevas condiciones de promoción
      this.agregarForm.get('cond_sub_canal').valueChanges.subscribe(this.validateConditionAndSavePromo);
      this.agregarForm.get('cond_canal_cliente').valueChanges.subscribe(this.validateConditionAndSavePromo);
      // T.20331
    }

  }

  private buildForm() {
    this.agregarForm = this.formBuilder.group({
      id_promo: ['', [Validators.required, Validators.maxLength(6), Validators.minLength(6)]],
      descripcion_corta: ['', [Validators.maxLength(40), Validators.required]],
      descripcion_larga: ['', [Validators.maxLength(200)]],
      fecha_inicio: ['', []],
      fecha_fin: ['', []],
      tipo_promo: ['', [Validators.required]],
      especif_calculo_cantidad: ['', [Validators.required]],
      promo_exclusiva_hh: ['', []],
      excluye_bonificacion_hh: ['', []],
      aplica_proporcionalidad: ['', []],
      cantidad_minima: [null, [Validators.min(0)]],
      cantidad_maxima: [null, [Validators.min(0)]],
      control_cantidad: ['', []],
      control_maximo: ['', []],
      cambio_condicion_pago: ['', []],
      condicion_pago: ['', []],
      suma_por_grupos: ['', []],
      aplica_compensacion: ['', []],
      porcentaje_descuento: [null, []],
      monto_inicial: [null, []],
      monto_final: [null, []],
      cond_marca_submarca: [3, []],
      numero_maximo_compras: [null, []],
      cond_grupo_cliente: [3, []],
      cond_cliente: [3, []],
      cond_vendedor: [3, []],
      cond_oficina_venta: [3, []],
      negociacion_puntal: ['', []],
      cond_tiers: [3, []],
      
      // T.20331 Essential:  nuevas condiciones de promoción
      cond_sub_canal: [3, []],
      cond_canal_cliente: [3, []],
    });
  }

  onChangeTipoOnSelect(event: Event){
    const tipo = (event.target as HTMLInputElement).value;
    this.onChangeTipo(tipo);
  }

  onChangeTipo(tipo) {
    this.loading = true;
    this.setALLNoRequiredAndEnable();

    if(!this._promocion) {
      this.agregarForm.get('aplica_proporcionalidad').setValue('1');
    }
    this.agregarForm.get('porcentaje_descuento').disable();
    if (tipo == 0) return;
    switch (tipo.toString()) {
      // case 'POR_BONIFICACION_PROPORCIONAL':
      case '1':
        // FORMULARIO PROMOCION
        this.setKeyEmptyDisabled('condicion_pago', '');
        this.setKeyEmptyDisabled('promo_exclusiva_hh', '');
        this.setKeyEmptyDisabled('cambio_condicion_pago', '');
        break;
      // case 'BONIFICACION_PROPORCIONAL_OTROS_ITEMS':
      case '2':
        this.setKeyEmptyDisabled('control_maximo', '');
        this.setKeyEmptyDisabled('promo_exclusiva_hh', '');
        this.setKeyEmptyDisabled('cambio_condicion_pago', '');
        this.setKeyEmptyDisabled('condicion_pago', '');
        break;
      // case 'PROPORCIONAL_VDI':
      case '3':
        this.setKeyEmptyDisabled('especif_calculo_cantidad', '');
        this.setKeyEmptyDisabled('cantidad_minima');
        this.setKeyEmptyDisabled('control_maximo', '');
        this.setKeyEmptyDisabled('control_cantidad', '');
        this.setKeyEmptyDisabled('cambio_condicion_pago', '');
        this.setKeyEmptyDisabled('condicion_pago', '');
        this.setKeyEmptyDisabled('excluye_bonificacion_hh', '');
        this.setKeyEmptyDisabled('suma_por_grupos', '');
        this.setKeyEmptyDisabled('aplica_compensacion', '');
        this.setKeyEmptyDisabled('porcentaje_descuento');
        this.agregarForm.get('promo_exclusiva_hh').setValue(1);
        break;
      // case 'POR_COMPRAS_CONSECUTIVAS':
      case '4':
        this.setKeyEmptyDisabled('control_maximo', '');
        this.setKeyEmptyDisabled('promo_exclusiva_hh', '');
        this.setKeyEmptyDisabled('cambio_condicion_pago', '');
        this.setKeyEmptyDisabled('condicion_pago', '');
        this.setKeyEmptyDisabled('suma_por_grupos', '');
        this.setKeyEmptyDisabled('aplica_compensacion', '');
        this.setKeyEmptyDisabled('porcentaje_descuento');
        break;
      // case 'POR_MONTO_MINIMO':
      case '5':
        this.setKeyEmptyDisabled('cantidad_minima');
        this.setKeyEmptyDisabled('cantidad_maxima');
        this.setKeyEmptyDisabled('control_maximo', '');
        this.setKeyEmptyDisabled('control_cantidad', '');
        this.setKeyEmptyDisabled('promo_exclusiva_hh', '');
        this.setKeyEmptyDisabled('aplica_proporcionalidad', '');
        this.setKeyEmptyDisabled('cambio_condicion_pago', '');
        this.setKeyEmptyDisabled('condicion_pago', '');
        this.setKeyEmptyDisabled('suma_por_grupos', '');
        this.setKeyEmptyDisabled('aplica_compensacion', '');
        this.setKeyEmptyDisabled('porcentaje_descuento');
        this.setKeyEmptyDisabled('especif_calculo_cantidad');
        this.agregarForm.get('especif_calculo_cantidad').setValue(2);
        break;
      // case 'PROMO_DESCUENTO_ADICIONAL':
      case '6':
        this.setKeyEmptyDisabled('especif_calculo_cantidad', '');
        this.setKeyEmptyDisabled('cantidad_minima');
        this.setKeyEmptyDisabled('cantidad_maxima');
        this.setKeyEmptyDisabled('control_maximo', '');
        this.setKeyEmptyDisabled('control_cantidad', '');
        this.setKeyEmptyDisabled('promo_exclusiva_hh', '');
        this.setKeyEmptyDisabled('aplica_proporcionalidad', '');
        this.setKeyEmptyDisabled('cambio_condicion_pago', '');
        this.setKeyEmptyDisabled('condicion_pago', '');
        this.setKeyEmptyDisabled('suma_por_grupos', '');
        break;
      // case 'PROMO_BONIFICACION_COMPENSACION':
      case '7':
        this.setKeyEmptyDisabled('promo_exclusiva_hh', '');
        this.setKeyEmptyDisabled('aplica_proporcionalidad', '');
        this.setKeyEmptyDisabled('cambio_condicion_pago', '');
        this.setKeyEmptyDisabled('condicion_pago', '');
        this.setKeyEmptyDisabled('aplica_compensacion', '');
        break;
      // case 'CONSIGNACION':
      case '8':
        this.setKeyEmptyDisabled('especif_calculo_cantidad', '');
        this.setKeyEmptyDisabled('cantidad_minima');
        this.setKeyEmptyDisabled('cantidad_maxima');
        this.setKeyEmptyDisabled('control_maximo', '');
        this.setKeyEmptyDisabled('control_cantidad', '');
        this.setKeyEmptyDisabled('promo_exclusiva_hh', '');
        this.setKeyEmptyDisabled('aplica_proporcionalidad', '');
        this.setKeyEmptyDisabled('cambio_condicion_pago', '');
        this.setKeyEmptyDisabled('condicion_pago', '');
        this.setKeyEmptyDisabled('suma_por_grupos', '');
        this.setKeyEmptyDisabled('aplica_compensacion', '');
        this.setKeyEmptyDisabled('porcentaje_descuento');
        break;
      // case 'YAPA':
      case '9':
        this.setKeyEmptyDisabled('promo_exclusiva_hh', '');
        this.setKeyEmptyDisabled('especif_calculo_cantidad', '');
        this.setKeyEmptyDisabled('cantidad_minima');
        this.setKeyEmptyDisabled('control_maximo', '');
        this.setKeyEmptyDisabled('aplica_proporcionalidad', '');
        this.setKeyEmptyDisabled('cambio_condicion_pago', '');
        this.setKeyEmptyDisabled('aplica_compensacion', '');
        this.setKeyEmptyDisabled('porcentaje_descuento');
        break;
      // case 'COMBO_VIRTUAL' T.25842.sn
      case '10':
        this.setKeyEmptyDisabled('especif_calculo_cantidad', '');
        this.setKeyEmptyDisabled('control_maximo', '');
        this.setKeyEmptyDisabled('excluye_bonificacion_hh', '');
        this.setKeyEmptyDisabled('control_cantidad', '');
        this.setKeyEmptyDisabled('aplica_proporcionalidad', '');
        this.setKeyEmptyDisabled('cambio_condicion_pago', '');
        this.setKeyEmptyDisabled('condicion_pago', '');
        this.setKeyEmptyDisabled('suma_por_grupos', '');
        this.setKeyEmptyDisabled('aplica_compensacion', '');
        this.setKeyEmptyDisabled('porcentaje_descuento');
        break; 
      //T.25842.en  
      default:
        this.setALLNoRequiredAndDisabled();
        this.setAgregarFormDefaultValues();
        break;
    }
    this.loading = false;
  }


  setALLNoRequiredAndEnable() {
    Object.keys(this.agregarForm.controls).forEach(key => {
      this.agregarForm.get(key).setValidators([]);
      this.agregarForm.get(key).updateValueAndValidity();
      this.agregarForm.get(key).enable();
    });

    this.agregarForm.get('id_promo').setValidators([Validators.required, Validators.maxLength(6), Validators.minLength(6)]);

    this.agregarForm.get('id_promo').setAsyncValidators([]);
    this.agregarForm.get('id_promo').updateValueAndValidity();
    if (this.isCreate) {
      this.agregarForm.get("id_promo").enable();
      this.agregarForm.get('id_promo').setAsyncValidators([ValidatorAsyncCheckPromocion(this.promocionesService)]);
    }
    else this.agregarForm.get("id_promo").disable();
    this.agregarForm.get('descripcion_corta').setValidators([Validators.maxLength(40), Validators.required]);
    this.agregarForm.get("descripcion_corta").enable();
    this.agregarForm.get('descripcion_larga').setValidators([Validators.maxLength(200)]);
    this.agregarForm.get('descripcion_larga').updateValueAndValidity();
    this.agregarForm.get("descripcion_larga").enable();

    this.agregarForm.get('tipo_promo').setValidators([Validators.required]);
    this.agregarForm.get('tipo_promo').updateValueAndValidity();
    this.agregarForm.get("tipo_promo").enable();

    this.agregarForm.get('fecha_inicio').setValidators([Validators.maxLength(200)]);
    this.agregarForm.get('fecha_inicio').updateValueAndValidity();
    this.agregarForm.get("fecha_inicio").enable();
    this.agregarForm.get('fecha_fin').setValidators([Validators.maxLength(200)]);
    this.agregarForm.get('fecha_fin').updateValueAndValidity();
    this.agregarForm.get("fecha_fin").enable();
    this.agregarForm.get('porcentaje_descuento').setValidators([Validators.required, Validators.max(99), Validators.min(0)]);
    this.agregarForm.get('cantidad_minima').setValidators([Validators.required, Validators.min(1), Validators.max(99999)]);
    this.agregarForm.get('cantidad_maxima').setValidators([Validators.required, Validators.min(1), Validators.max(999999)]);
    this.agregarForm.get('monto_inicial').setValidators([Validators.required, Validators.min(1), Validators.max(99999)]);
    this.agregarForm.get('monto_final').setValidators([Validators.required, Validators.min(1), Validators.max(999999)]);
    this.agregarForm.get('numero_maximo_compras').setValidators([Validators.required, Validators.min(1), Validators.max(99999)]);
    this.agregarForm.get('especif_calculo_cantidad').setValidators([Validators.required]);
    this.agregarForm.get('especif_calculo_cantidad').updateValueAndValidity();
    if (!this._promocion) {
      this.agregarForm.get('porcentaje_descuento').setValue(0);
      this.agregarForm.get('cantidad_minima').setValue(0);
      this.agregarForm.get('cantidad_maxima').setValue(0);
      this.agregarForm.get('monto_inicial').setValue(0);
      this.agregarForm.get('monto_final').setValue(0);
      this.agregarForm.get('numero_maximo_compras').setValue(0);
    }
  }

  setALLNoRequiredAndDisabled() {
    Object.keys(this.agregarForm.controls).forEach(key => {
      this.agregarForm.get(key).setValidators([]);
      this.agregarForm.get(key).updateValueAndValidity();
      this.agregarForm.get(key).disable();
    });

    this.agregarForm.get('id_promo').setValidators([Validators.required, Validators.maxLength(6), Validators.minLength(6)]);
    this.agregarForm.get('id_promo').setAsyncValidators([]);
    this.agregarForm.get('id_promo').updateValueAndValidity();
    if (this.isCreate) {
      this.agregarForm.get('id_promo').setAsyncValidators([ValidatorAsyncCheckPromocion(this.promocionesService)]);
      this.agregarForm.get("id_promo").enable();
    }
    else this.agregarForm.get("id_promo").disable();

    this.agregarForm.get('tipo_promo').setValidators([Validators.required]);
    this.agregarForm.get('tipo_promo').updateValueAndValidity();
    this.agregarForm.get("tipo_promo").enable();

    this.agregarForm.get('descripcion_corta').setValidators([Validators.maxLength(40), Validators.required]);
    this.agregarForm.get('descripcion_corta').updateValueAndValidity();
    this.agregarForm.get("descripcion_corta").enable();
    this.agregarForm.get('descripcion_larga').setValidators([Validators.maxLength(200)]);
    this.agregarForm.get('descripcion_larga').updateValueAndValidity();
    this.agregarForm.get("descripcion_larga").enable();
    this.agregarForm.get('fecha_inicio').setValidators([Validators.maxLength(200)]);
    this.agregarForm.get('fecha_inicio').updateValueAndValidity();
    this.agregarForm.get("fecha_inicio").enable();
    this.agregarForm.get('fecha_fin').setValidators([Validators.maxLength(200)]);
    this.agregarForm.get('fecha_fin').updateValueAndValidity();
    this.agregarForm.get("fecha_fin").enable();
    this.agregarForm.get('porcentaje_descuento').setValidators([Validators.required, Validators.max(99), Validators.min(0)]);
    this.agregarForm.get('cantidad_minima').setValidators([Validators.required, Validators.min(1), Validators.max(99999)]);
    this.agregarForm.get('cantidad_maxima').setValidators([Validators.required, Validators.min(1), Validators.max(999999)]);
    this.agregarForm.get('monto_inicial').setValidators([Validators.required, Validators.min(1), Validators.max(99999)]);
    this.agregarForm.get('monto_final').setValidators([Validators.required, Validators.min(1), Validators.max(999999)]);
    this.agregarForm.get('numero_maximo_compras').setValidators([Validators.required, Validators.min(1), Validators.max(99999)]);
  }

  setAgregarFormDefaultValues() {
    this.agregarForm.get('tipo_promo').setValue('');
    this.agregarForm.get('promo_exclusiva_hh').setValue('');
    this.agregarForm.get('excluye_bonificacion_hh').setValue('');
    this.agregarForm.get('aplica_proporcionalidad').setValue('');
    this.agregarForm.get('control_cantidad').setValue('');
    this.agregarForm.get('control_maximo').setValue('');
    this.agregarForm.get('condicion_pago').setValue('');
    this.agregarForm.get('cambio_condicion_pago').setValue('');
    this.agregarForm.get('suma_por_grupos').setValue('');
    this.agregarForm.get('aplica_compensacion').setValue('');
    this.agregarForm.get('monto_inicial').setValue(null);
    this.agregarForm.get('monto_final').setValue(null);
    this.agregarForm.get('cond_marca_submarca').setValue(3);
    this.agregarForm.get('cantidad_minima').setValue(null);
    this.agregarForm.get('cantidad_maxima').setValue(null);
    this.agregarForm.get('cond_grupo_cliente').setValue(3);
    this.agregarForm.get('cond_cliente').setValue(3);
    this.agregarForm.get('cond_oficina_venta').setValue(3);
    this.agregarForm.get('cond_vendedor').setValue(3);
    this.agregarForm.get('negociacion_puntal').setValue('');
    this.agregarForm.get('especif_calculo_cantidad').setValue('');
    this.agregarForm.get('numero_maximo_compras').setValue(null);
    this.agregarForm.get('porcentaje_descuento').setValue(null);
    this.agregarForm.get('descripcion_corta').setValue('');
    this.agregarForm.get('cond_tiers').setValue(3);

    // T.20331 Essential:  nuevas condiciones de promoción
    this.agregarForm.get('cond_sub_canal').setValue(3);
    this.agregarForm.get('cond_canal_cliente').setValue(3);
    // T.20331
  }

  setKeyEmptyDisabled(key, value = null) {
    // console.log("form, key", form, key)
    this.agregarForm.get(key).setValue(value);
    this.agregarForm.get(key).setValidators([]);
    this.agregarForm.get(key).updateValueAndValidity();
    this.agregarForm.get(key).disable();
  }

  acciones(event: string) {
    if (event === 'guardar') {
      this.save(false);
    } else {
      this.back.emit();
    }
  }

  save(autosave: boolean) {
    const promo = this.agregarForm.getRawValue();
    this.create.emit({ autosave, promo });
  }

  nuevo() {
    this.setALLNoRequiredAndEnable();
    this.agregarForm.reset();
    this.isCreate = true;
    this.setAgregarFormDefaultValues();
    this.onChangeTipo('');
    var now = new Date();
    var day = ("0" + now.getDate()).slice(-2);
    var month = ("0" + (now.getMonth() + 1)).slice(-2);
    var today = now.getFullYear() + "-" + (month) + "-" + (day);
    this.agregarForm.get('fecha_inicio').setValue(today);
    this.agregarForm.get('fecha_fin').setValue(today);
  }

  private validateConditionAndSavePromo = (value) => {
    if ((value == 1 || value == 2) && this.agregarForm.valid && !this.loading)
      this.save(true);
  }

}
